import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { constantsSlice } from './slices/constants';
import { userSlice } from './slices/currentUser';
import { customerSlice } from './slices/customers';
import { tableConfigSlice } from './slices/tableConfig';
import { usersSlice } from './slices/users';
import { querySlice } from './slices/query';

const combinedReducer = combineReducers({
  currentUser: userSlice.reducer,
  customers: customerSlice.reducer,
  constants: constantsSlice.reducer,
  tableConfig: tableConfigSlice.reducer,
  users: usersSlice.reducer,
  queries: querySlice.reducer,
});

// eslint-disable-next-line
const rootReducer = (state: any, action: any) => {
  if (action.type === 'user/logout') {
    state = undefined; // eslint-disable-line
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store };
